export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const setMessage = (message, errors = []) => (dispatch) =>
  dispatch({ type: SET_MESSAGE, payload: message, errors });

export const SET_LOADING = 'SET_LOADING';
export const CLEAR_LOADING = 'CLEAR_LOADING';
